import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { generateHtmlId } from '../../../utils'
import { useTranslation } from '../../../hooks'

const Textarea = ({ name, label, placeholder, value, errorMessage, onChange = () => {}, onBlur = () => {}, disabled }) => {
  const { i18n } = useTranslation();
  const { current: id } = useRef(generateHtmlId());
  const compileClassNames = () => {
    let className = 'field field--textarea';
    if (errorMessage) className += ' field field--textarea';
    if (disabled) className += ' field--disabled';
    return className;
  }

  return (
    <div className={compileClassNames()}>
      <label className="field__label" htmlFor={id}>{i18n(label)}</label>
      <div className="field__input-wrapper">
        <textarea disabled={disabled} onBlur={onBlur} onChange={onChange} className="field__input" id={id} name={name} placeholder={placeholder} value={value}></textarea>
      </div>
      {errorMessage && <small className="field__error-message">{i18n(errorMessage)}</small>}
    </div>
  )
}


Textarea.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool
}

export default Textarea
